// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__xXvAc","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__38BtZ"};